import React from 'react';
import { Tooltip } from '@mui/material';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';
import SwipeRightIcon from '@mui/icons-material/SwipeRight';
import { Link } from 'react-router-dom';

export const ReciveSalesToLeed = ({ user }) => {
  //     //==============================recive leed
  // const[loadingrecivesalestoleed,setloadingrecivesalestoleed]=useState(true)

  // const reciveleedaction=async(e)=>{
  //   e.preventDefault();

  //   setloadingrecivesalestoleed(true);
  //   await dispatch(UpdateClientAction(user._id,{
  // assign:false
  //   }))
  //   setloadingrecivesalestoleed(false)
  //   Notify('success','Successfully updated','success')
  //   setTimeout(() => { window.location.reload(false) }, 500)

  // }

  // //================================================
  return (
    <div
      style={{
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
      }}
    >
      <Tooltip title="Sales Received" placement="left-start">
        <div style={{ color: '#102dff' }}>
          <Link to={`/salesReciveLeed/${user._id}`}>
            <div
              className="button-5"
              style={{
                background: 'white',
                border: '2px solid royalblue',
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '20%',
                cursor: 'pointer',
              }}
            >
              <TouchAppOutlinedIcon style={{ color: '#102dff' }} />
            </div>
          </Link>
        </div>
      </Tooltip>
    </div>
  );
};
